module.exports = __webpack_public_path__ + "cbffea2e14a2f27f29c37ddc9d645876.svg";